import { useTranslation } from 'react-i18next';
import { Card, Row, Col } from 'react-bootstrap';
import { FormTextField } from '../../../../../components';
import { OptInCheckBoxArray } from './OptInCheckBoxArray';
import { Court } from '../../../../../types/tournament';
import { IScheduleDayConstraints } from '../../../../../types/schedule';
import { getDateString, getTournamentTimezone } from '../schedule.helpers';
import { useAppSelector } from '../../../../../hooks/redux';
import { selectSchedule } from '../../../../../features/schedule/scheduleSelectors';

interface DayVenuesSetupProps {
  day: IScheduleDayConstraints;
  courts: Court[];
}

export const DayVenuesSetup = ({ day, courts }: DayVenuesSetupProps) => {
  const { t } = useTranslation();
  const prefix = 'creativeDetail-';

  const { tournamentInfo } = useAppSelector(selectSchedule);
  const timeZone = getTournamentTimezone(tournamentInfo?.country, tournamentInfo?.timeZone);
  
  return (
    <Card className="mb-4 shadow-sm border rounded">
      <Card.Body className="p-4">
        <Row className="mb-3 border-bottom pb-2">
          <Col>
            <h4 className="font-weight-bold mb-0">
              {t(prefix + 'scheduleDay')} {day.dayKey + 1}{' '}
              <span className="text-muted fs-5 font-weight-normal">
                ({getDateString(day.startTime, timeZone)})
              </span>
            </h4>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col sm={6} className="mb-2">
            <FormTextField
              type="time"
              name={`startOfDay-${day.dayKey}`}
              label={t(prefix + 'startOfDayLabel')}
            />
          </Col>
          <Col sm={6} className="mb-2">
            <FormTextField
              type="time"
              name={`endOfDay-${day.dayKey}`}
              label={t(prefix + 'endOfDayLabel')}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <OptInCheckBoxArray name="court" dayKey={day.dayKey} data={courts} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};